import { tracking } from '@iwoca/frontend-tracking-library';
import { fetchGetCompanySearch } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { TGetCompanySearchResponseDE } from '../../lapiOverrideTypesDE';

export function useGetCompanySearch({
  searchQuery,
  enabled,
  splitTestBranch,
}: {
  searchQuery: string;
  enabled?: boolean;
  splitTestBranch: string | null;
}) {
  return useQuery({
    queryKey: ['companySearch', searchQuery, splitTestBranch],
    queryFn: async () => {
      tracking.ampli.companySearchUsed({
        query_length: searchQuery.length,
      });

      const query =
        splitTestBranch === 'INCLUDE'
          ? { phrase: searchQuery }
          : { company_name: searchQuery };

      return await fetchGetCompanySearch({
        query,
      });
    },
    // @ts-expect-error LAPI client uses UK typing, overriding to DE
    select: (data) => data as TGetCompanySearchResponseDE,
    enabled: !!searchQuery && enabled,
  });
}
